const NOTES_TO_LOAD = 15;
const NOTE_COMMENT_MAX_LENGTH = 750;
const NOTE_MAX_LENGTH = 950;
const NOTE_CLICK_DEBOUNCE_TIME = 175;

const LANE_NAMES = {
  TO_DO: 'to_do',
  TO_EXECUTE: 'to_execute',
  DOING: 'doing',
  DONE: 'done',

  BUILD_THE_PRODUCT: 'build_product',
  RECRUITING: 'recruiting',
  FINANCES: 'finances',
  BMC: 'bmc'
};

const LANE_NAMES_TO_INTEGER = {
  [LANE_NAMES.TO_DO]: 0,
  [LANE_NAMES.TO_EXECUTE]: 0,
  [LANE_NAMES.DOING]: 1,
  [LANE_NAMES.DONE]: 2,

  [LANE_NAMES.BUILD_THE_PRODUCT]: 3,
  [LANE_NAMES.RECRUITING]: 4,
  [LANE_NAMES.FINANCES]: 5,
  [LANE_NAMES.BMC]: 6
};

const BOARD_TYPES = {
  TASK: 'IgtasksBoard',
  CEO: 'IgceoBoard'
};

const PRIORITIES = {
  LOW: 'low_priority',
  MEDIUM: 'medium_priority',
  HIGH: 'high_priority'
};

const PRIORITIES_TO_INTEGER = {
  [PRIORITIES.LOW]: 0,
  [PRIORITIES.MEDIUM]: 1,
  [PRIORITIES.HIGH]: 2
};

const COMPLEXITY = {
  EASY: 'easy_complexity',
  MEDIUM: 'medium_complexity',
  HARD: 'hard_complexity'
};

const COMPLEXITY_TO_INTEGER = {
  [COMPLEXITY.EASY]: 0,
  [COMPLEXITY.MEDIUM]: 1,
  [COMPLEXITY.HARD]: 2
};

const ROUTE_PATH =
  '/:locale?/(value_propositions/\\d+/\\w+/tasks/\\d+|value_propositions/\\d+|igtasks/\\d+/tasks|igceo/startups/\\d*)';

const TODO_ITEM_STATUSES = {
  TODO: 'todo',
  DOING: 'doing',
  DONE: 'done'
};

const TODO_ITEM_STATUSES_TO_INTEGER = {
  [TODO_ITEM_STATUSES.TODO]: 0,
  [TODO_ITEM_STATUSES.DOING]: 1,
  [TODO_ITEM_STATUSES.DONE]: 2
};

const LABEL_COLORS = [
  '#FF6900',
  '#FCB900',
  '#7BDCB5',
  '#00D084',
  '#8ED1FC',
  '#0693E3',
  '#ABB8C3',
  '#EB144C',
  '#F78DA7',
  '#9900EF'
];

const MENTIONS_CLASS_NAMES = {
  mentions__input: 'form-control mentions__input',
  mentions__mention: 'mentions__mention',
  mentions__control: 'mentions__control',
  mentions__higlighter: 'mentions__higlighter',
  mentions__suggestions__list: 'mentions__suggestions__list',
  mentions__suggestions__item: 'mentions__suggestions__item',
  'mentions__suggestions__item--focused': 'mentions__suggestions__item--focused'
};

const ACTIVITIES = {
  CARD: {
    DUE_DATE: { SET: 'card.due_date.set', REMOVE: 'card.due_date.remove' },
    LIST: {
      TODO: 'card.list.to_do',
      DOING: 'card.list.doing',
      DONE: 'card.list.done'
    },
    PRIORITY: {
      MEDIUM: 'card.priority.medium_priority',
      HIGH: 'card.priority.high_priority'
    },
    ASSIGNEE: { SET: 'card.assignee.set', REMOVE: 'card.assignee.remove' }
  },
  CARD_COMMENT: { CREATE: 'card_comment.create' }
};

const CARD_RELATIONS = {
  RELATED_TO: 'related_to',
  DUPLICATE: 'duplicate',
  BLOCKS: 'blocks',
  BLOCKED_BY: 'blocked_by'
};

const WEEK_DAYS = {
  SUNDAY: 'sun',
  MONDAY: 'mon',
  TUESDAY: 'tu',
  WEDNESDAY: 'wed',
  THURSDAY: 'th',
  FRIDAY: 'fri',
  SATURDAY: 'sat'
};

export {
  NOTES_TO_LOAD,
  LANE_NAMES,
  LANE_NAMES_TO_INTEGER,
  COMPLEXITY,
  COMPLEXITY_TO_INTEGER,
  PRIORITIES,
  PRIORITIES_TO_INTEGER,
  BOARD_TYPES,
  ROUTE_PATH,
  TODO_ITEM_STATUSES,
  TODO_ITEM_STATUSES_TO_INTEGER,
  LABEL_COLORS,
  MENTIONS_CLASS_NAMES,
  ACTIVITIES,
  CARD_RELATIONS,
  NOTE_COMMENT_MAX_LENGTH,
  NOTE_MAX_LENGTH,
  NOTE_CLICK_DEBOUNCE_TIME,
  WEEK_DAYS
};
